export default __webpack_public_path__ + "static/media/shopeeurl.fc642ee3.png";